export class ServiceRoute {
  static account = {
    login: "/api/Accounts/CreateToken",
    register: "/api/Accounts/Register",
    registerDirect: "/api/Accounts/RegisterDirect",
    changePass: "/api/Accounts/ChangePassword",
    confirmRegistration: "/api/Accounts/UserActivate",
    resendCode: "/api/Accounts/GetNewActivateCode",
    forgottenPassword: "/api/Accounts/ForgetPassword",
    getSimpleUserInfo: "/api/Accounts/GetSimpleUserInfo?xNationalCode=",
    CheckActivateUser: "/api/Accounts/CheckActivateUser",
    userForgetPassByAdmin: "/api/Accounts/UserForgetPassByAdmin",
    updateUserProfile: "/api/Accounts/UpdateUserProfile", // بروز رسانی اطلاعات کاربری
    urerList: "/api/Accounts/UrerList",
    userActivationByAdmin: "/api/Accounts/UserActivationByAdmin",
    getUserInfo: "/api/Accounts/GetUserInfo",
    getUserInfoByNationalCode: "/api/Accounts/GetUserInfoByNationaCode?xNationaCode=",
    introductionMethodList: "/api/Accounts/IntroductionMethodList"

  };
  static provinces = {
    list: "/api/Address/ProvinceList"
  };
  static cities = {
    list: "/api/Address/CityListByProvinveId?xProvinceId="
  };
  static area = {
    list: "/api/Address/AreaListByCityId?xCityId="
  };
  static phoneType = {
    list: "/api/StaticValue/GetPhoneType?xHasDefault=false"
  };
  static holding = {
    add: "/api/Holding/Add",
    edit: "/api/Holding/Edit",
    list: "/api/Holding/List",
    AllList: "/api/Holding/AllList",
    delete: "/api/Holding/Delete?xId=",
    getById: "/api/Holding/GetById?xId=",
    checkOwnerHolding: "/api/Holding/CheckOwnerHolding"
  };
  static company = {
    list: "/api/Company/List",
    add: "/api/Company/Add",
    edit: "/api/Company/Edit",
    delete: "/api/Company/Delete",
    addManager: "/api/Company/GetManagerInfo",
    saveManager: "/api/Company/SaveManager",
    companyById: "/api/Company/CompanyById/"
  };
  static majorDegree = {
    majorList: "/api/DegreeMajor/DegreeList",
    degreeList: "/api/DegreeMajor/DegreeById?xId="
  };
  static job = {
    list: "/api/Job/List",
  };
  static group = {
    getById: "/api/Group/GetById?xId=",
    list: "/api/Group/List?ParentChildMode=true&xPage=0&xPageSize=0",
    add: "/api/Group/Add",
    edit: "/api/Group/Edit",
    delete: "/api/Group/Delete"
  };
  static branch = {
    add: "/api/Branch/Add",
    edit: "/api/Branch/Edit",
    addAccount: "/api/Branch/AddAccount",
    listByLogin: "/api/Branch/ListbyLogin",
    listByHoldingId: "/api/Branch/ListByHoldingId",
    listByHoldingIdAndCurrentSTU: "/api/Branch/ListByHoldingIdAndCurrentSTU",
    listAccount: "/api/Branch/ListAccount",
    getById: "/api/Branch/BranchById?xBranchEncryptId=",
    delete: "/api/Branch/Delete?EncryptId=",
    changeStatus: "/api/Branch/ChangeStatus",
    list: "/api/Branch/List?JustActiveBranch=",
    getAghBranchInCompany: "/api/Branch/GetAghBranchInCompany",
    holdingBranchsList: "/api/Branch/HoldingBranchs",
    getpresenceBranchByProvinceId: "/api/Branch/GetpresenceBranchByProvinceId?xProvinceId=",
    getBranchFroPrivateCourseRequest: "/api/Branch/GetBranchFroPrivateCourseRequest?xProvinceId="

  };
  static role = {
    getById: "/api/Role/GetById?xId=",
    list: "/api/Role/List?ParentChildMode=true&xPageSize=0&xOrderBy=0",
    fullList: "/api/Role/FullList?ParentChildMode=false&xPageSize=0&xOrderBy=0",
    add: "/api/Role/Add",
    edit: "/api/Role/Edit",
    delete: "/api/Role/Delete"
  };
  static staticValue = {
    bankList: "/api/StaticValue/BankList?xHasDefault=",
    getPhoneType: "/api/StaticValue/GetPhoneType?xHasDefault=",
    companyStatusType: "/api/StaticValue/CompanyStatusType?xHasDefault=",
    genderType: "/api/StaticValue/GenderType?xHasDefault=",
    branchType: "/api/StaticValue/BranchType?xHasDefault=",
    userType: "/api/StaticValue/UserType?xHasDefault=",
    roomType: "/api/StaticValue/RoomType?xHasDefault=",
    relationType: "/api/StaticValue/RelationType?xHasDefault=",
    questionType: "/api/StaticValue/QuestionType?xHasDefault=",
    courseStatus: "/api/StaticValue/CourseStatus?xHasDefault=",
    discountGroupType: "/api/StaticValue/DiscountGroupType?xHasDefault=",
    weekDays: "/api/StaticValue/WeekDays?xHasDefault=",
    degree: "/api/StaticValue/Degree?xHasDefault=",
    ageCategory: "/api/StaticValue/AgeCategory?xHasDefault=",
    languageList: "/api/StaticValue/LanguageList?xHasDefault=",
    ContractType: "/api/StaticValue/ContractType?xHasDefault=false",
    RelationType: "/api/StaticValue/",
    InvoiceStatus: "/api/StaticValue/InvoiceStatus?xHasDefault=",
    AllInvoiceItemType: "/api/StaticValue/AllInvoiceItemType?xHasDefault="
  };
  static groupRole = {
    getById: "/api/GroupRole/GetGroupListByRoleId?xRoleId=",
    save: "/api/GroupRole/BatchSaveRoleGroupList"
  };

  static groupRouteAction = {
    list: "/api/Route/ListForManager",
    GetActionListByGroupId:
      "/api/GroupRouteAction/GetActionListByGroupId?xGroupId=",
    saveActionListByGroupId: "/api/GroupRouteAction/GetActionGroupSave"
  };

  static contract = {
    add: "/api/Contract/Add",
    edit: "/api/Contract/Edit",
    delete: "/api/Contract/Delete",
    list: "/api/Contract/List",
    getType: "/api/ContractType/List",
    getById: "/api/Contract/GetById?xId=",
    getInfo: "/api/Contract/GetContractInfo",
    GetContractBranchList: "/api/Contract/GetContractBranchList",
    getListTeacherInBranch: "/api/Contract/GetListTeacherInBranch",
    getListLastContractSave: "/api/Contract/GetListLastContractSave",
    getListPlacementInBranch: "/api/Contract/GetListPlacementInBranch?BranchEncryptId=",
    GetBranchContractUser: "/api/Contract/GetBranchContractUser?xBranchEncryptId=",
    getCompanyContractUser: "/api/Contract/GetCompanyContractUser",
    setLeavingJobDate: "/api/Contract/SetLeavingJobDate",
    getListPlacementInCompany: "/api/Contract/GetListPlacementInCompany",
    hasCurentUserTeacherContract: "/api/Contract/HasCurentUserTeacherContract?xCID=", //آیا کاربر جاری دارای قرارداد استادی می باشد
  };
  static gonbadSetting: {
    listGonbadSetting: "/api/GonbadSetting/ListGonbadSetting"
  };
  static companySetting = {
    getTimeLine: "/api/CompanySetting/GetSetting", //ساعت های شروع به کار و پایان کار شرکت
    indicator: "/api/CompanySetting/CreateIndicator",
    getContractDate: "/api/CompanySetting/GetContractDate", // تا چند روز قبل از روز جاری میتونه قرارداد ثبت کنه
    listGonbadSetting: "/api/GonbadSetting/ListGonbadSetting"
  };

  // exceptional Coefficients   ضرایب استثنایی
  static exceptionalCoefficients = {
    coefficientsList: "/api/ExceptionalCoefficients/List",   // دریافت اطلاعات مربوط به ضرایب
    coefficientsAdd: "/api/ExceptionalCoefficients/Add", //ثبت ضرایب استثنا C
    coefficientsEdit: "/api/ExceptionalCoefficients/Edit", //ثبت ضرایب استثنا C
    //coefficientsEdit:"/api/ExceptionalCoefficients/Edit", //ویرایش ضرایب استثنا C
    coefficientsDelete: "/api/ExceptionalCoefficients/Delete", //ویرایش ضرایب استثنا C
    getCoefficient: "/api/ExceptionalCoefficients/GetCoefficient",
    setCoefficientAfterTime: "/api/ExceptionalCoefficients/SetCoefficientAfterTime"
  };

  static coutsePattern = {
    add: "/api/CoursePattern/Add",
    list: "/api/CoursePattern/List",
    edit: "/api/CoursePattern/Edit",
    getById: "/api/CoursePattern/CoursePatternById?xId=",
    delete: "/api/CoursePattern/Delete",
    PatternActive: "/api/CoursePattern/PatternActive",
    getListByCourseTypeId:
      "/api/CoursePattern/CoursePatternListByCourseTypeId?xCourseTypeId="
  };
  static courseType = {
    add: "/api/CourseType/Add",
    list: "/api/CourseType/List",
    edit: "/api/CourseType/Edit",
    delete: "/api/CourseType/Delete",
    getById: "/api/CourseType/CourseTypeById?xId=",
    CourseTypeListByCurentBranch: "/api/CourseType/CourseTypeListByCurentBranch",
    CourseTypeListForAddCourse: "/api/CourseType/CourseTypeListForAddCourse",
    courseTypeToggleState: "/api/CourseType/CourseTypeToggleState"
  };

  static room = {
    list: "/api/Room/List",
    // list: "/api/Room/List?xPageSize=100",
    getRoomListByBranchId: "/api/Room/GetRoomListByBranchId?xBranchEncryptId=",
    getById: "/api/Room/GetById?xId=",
    add: "/api/Room/Add",
    edit: "/api/Room/Edit",
    delete: "/api/Room/Delete?Id="
  };
  static calendar = {
    list: "/api/Calendar/List?xPersianYear=&xPersianMonth=&xCalendarHolidayId",
    getCalendarHolidayList: "/api/Calendar/CalendarHolidayList",
    edit: "/api/Calendar/Edit",
    calendarByDate: "/api/Calendar/ByDate",
    GetYearsList: "/api/Calendar/GetYearsList",
    holidayTypeList: "/api/Calendar/HolidayTypeList",
    calendarHolidayList: "/api/Calendar/HolidayTypeList",
    calendarHolidayListByCurentDate: "/api/Calendar/CalendarHolidayListByCurentDate",
    holidayTypeAdd: "/api/Calendar/HolidayTypeAdd",
    save: "/api/Calendar/Save",
    holidayTypeEdit: "/api/Calendar/HolidayTypeEdit",
    hasDateList: "/api/Calendar/HasDateList?xTermInfoId="
  };

  static survey = {
    list: "/api/SurQuestionCat/List",
    questionList: "/api/SurQuestion/List",
    surQuestionCatSave: "/api/SurQuestionCat/Save",
    surQuestionCatEdit: "/api/SurQuestionCat/Edit",
    surQuestionCatDelete: "/api/SurQuestionCat/Delete",
    surQuestionAdd: "/api/SurQuestion/Add",
    surQuestionEdit: "/api/SurQuestion/Edit",
    surQuestionActiveDeactive: "/api/SurQuestion/QuestionActiveDeactive",
    surQuestionDelete: "/api/SurQuestion/Delete"
  }

  static termInfo = {
    list: "/api/TermInfo/List",
    listCombo: "/api/TermInfo/ListCombo",
    listByCourseTypeId: "/api/TermInfo/ListByCourseTypeId",
    getById: "/api/TermInfo/GetById?xId=",
    add: "/api/TermInfo/Add",
    edit: "/api/TermInfo/Edit",
    StatusForEdit: "/api/TermInfo/StatusForEdit",
    ToggleTerm: "/api/TermInfo/ToggleTerm",
    ToggleTermInParentTerm: "/api/TermInfo/ToggleTermInParentTerm",
    ToConfirmTerm: "/api/TermInfo/ToConfirmTerm",
    delete: "/api/TermInfo/Delete?Id=",
    listByJustCourseTypeId: "/api/TermInfo/ListByJustCourseTypeId"
  };

  static course = {
    Add: "/api/Course/Add",
    AghAdd: "/api/Course/AghAdd",
    AghList: "/api/Course/AghList?CustomerContractId=",
    edit: "/api/Course/Edit",
    delete: "/api/Course/Delete",
    cancelCourse: "/api/Course/CancelCourse",
    activeCourse: "/api/Course/ActiveCourse",
    GetFirstDate: "/api/Course/GetFirstDate",
    list: "/api/Course/List",
    GetNewAllSession: "/api/Course/GetNewAllSession",
    GetFullTimeSession: "/api/Course/GetFullTimeSession",
    GetCourseForeMakeUp: "/api/Course/GetCourseForeMakeUp",
    GetListIndeterminate: "/api/Course/GetListIndeterminate",
    AddTeacherAfterCourse: "/api/Course/AddTeacherAfterCourse",
    CourseBatchClassDefinitionInNewTearm: "/api/Course/CourseBatchClassDefinitionInNewTearm",
    CourseBatchClassDelete: "/api/Course/CourseBatchClassDelete",
    RemoveTeacherFromCourse: "/api/Course/RemoveTeacherFromCourse",
    SaveMakeUp: "/api/CourseMakeUp/SaveMakeUp",
    SubSave: "/api/CourseAllSessionSub/SubSave",
    GetFreeSubTeacher: "/api/Course/GetFreeSubTeacher",
    SubDelete: "/api/CourseAllSessionSub/SubDelete",
    MakeUpDelete: "/api/CourseMakeUp/MakeUpDelete",
    GetFreeTeacherAfterCourse: "/api/Course/GetFreeTeacherAfterCourse",
    GetFreeTeacherInAddEditCourse: "/api/Course/GetFreeTeacherInAddEditCourse",
    getAttendance: "/api/Course/GetAttendance?ParentTermId=",
    saveAttendance: "/api/Course/SaveAttendance",
    saveAttendanceWithoutDate: "/api/Course/SaveAttendanceWithoutDate",
    getCourseSessionNotPresent: "/api/Course/GetCourseSessionNotPresent?Id=",
    GetCourseSession: "/api/Course/GetCourseSession?Id=",
    getCourseForEdit: "/api/Course/GetCourseForEdit",
    CourseChangeRoom: "/api/Course/CourseChangeRoom",
    UpdateFinalExamDate: "/api/Course/UpdateFinalExamDate",
    SetPrivateCoursePrice: "/api/Course/SetPrivateCoursePrice",
    GetPrivateCoursePrice: "/api/Course/GetPrivateCoursePrice?xCourseId=",
    GetPrivateClassRequestForUser: "/api/Course/GetPrivateClassRequestForUser",
    GetPrivateClassRequestForAdmin: "/api/Course/GetPrivateClassRequestForAdmin",
    SetPrivateClassRequestReviewed: "/api/Course/SetPrivateClassRequestReviewed",
    SavePrivateClassRequest: "/api/Course/SavePrivateClassRequest",
    DeletePrivateClassRequest: "/api/Course/DeletePrivateClassRequest",
    SendSMSToPerson: "/api/Course/SendSMSToPerson",
    SendSMSToClass: "/api/Course/SendSMSToClass",
    SendSMSToPattern: "/api/Course/SendSMSToPattern",
    GetTPAItemList: "/api/Course/GetTPAItemList?xCourseId=",
    GetTPADataDetails: "/api/Course/GetTPADataDetails?xTPADataGroupId=",
    GetTPADataList: "/api/Course/GetTPADataList?xCourseId=",
    GetTPADataListAll: "/api/Course/GetTPADataListAll",
    SaveTeacherTPAItem: "/api/Course/SaveTeacherTPAItem",
    DeleteTeacherTPAData: "/api/Course/DeleteTeacherTPAData",
    getCourseInfobyId: "/api/Course/GetCourseInfoById",
  };
  
  static adobeConnect = {
    login: "/api/AdobeConnect/Login",
    createMeeting: "/api/AdobeConnect/CreateMeeting",
    createMeetingForOneSession: "/api/AdobeConnect/CreateMeetingForOneSession",
    addStudentToVirtualCourse: "/api/AdobeConnect/AddStudentToVirtualCourse",
    addTeacherToVirtualCourse: "/api/AdobeConnect/AddTeacherToVirtualCourse",
    addSupervisorToVirtualCourse: "/api/AdobeConnect/AddSupervisorToVirtualCourse",
    addStudentToVirtualSession: "/api/AdobeConnect/AddStudentToVirtualSession",
    showSessionArchive: "/api/AdobeConnect/ShowSessionArchive?xSessionId="
    
  }

  static educationPackage = {
    add: "/api/PackageEducation/Add",
    edit: "/api/PackageEducation/Edit",
    list: "/api/PackageEducation/List",
    listMaster: "/api/PackageEducation/ListMaster?NationalCode=",
    delete: "/api/PackageEducation/Delete",
    getById: "/api/PackageEducation/GetById?xId=",
    GetBranchListByNationalCodeAndPackage:
      "/api/PackageEducation/GetBranchListByNationalCodeAndPackage"
  };

  static levelInfo = {
    add: "/api/LevelInfo/Add",
    getAllLevelForTeacher: "/api/LevelInfo/List",
    list: "/api/LevelInfo/List?PackageId=",
    getById: "/api/LevelInfo/GetById?xId=",
    listByEducationPackageId:
      "/api/LevelInfo/ListByEducationPackageId?xEducationPackageId=",
    active: "/api/LevelInfo/Active",
    edit: "/api/LevelInfo/Edit",
    delete: "/api/LevelInfo/Delete",
    SaveLevelToPerson: "/api/LevelInfo/SaveLevelToPerson",
    ListLevelPerson: "/api/LevelInfo/ListLevelPerson?xNationalCode="
  };

  static levelInfoPrerequisite = {
    add: "/api/LevelPrerequisite/Add",
    edit: "/api/LevelPrerequisite/Edit",
    delete: "/api/LevelPrerequisite/Delete",
    list: "/api/LevelPrerequisite/List?PackageId=",
    getById: "/api/LevelPrerequisite/GetById?xId=",
    getLevelInfo: "/api/LevelPrerequisite/GetLevelInfo?xId="
  };

  static levelPrice = {
    list: "/api/LevelPrice/List?LevelId=",
    add: "/api/LevelPrice/Save",
    delete: "/api/LevelPrice/Delete"
  };

  static courseHistory = {
    list: "/api/CourseHistory/List",
    getById: "/api/CourseHistory/ById?xId=",
    add: "/api/CourseHistory/Add",
    edit: "/api/CourseHistory/Edit",
    delete: "/api/CourseHistory/Delete?Id="
  };

  static discountGroup = {
    addOther: "/api/DiscountGroup/AddOther",
    editOther: "/api/DiscountGroup/EditOther",
    addClassPersonDiscount: "/api/DiscountGroup/AddClassPersonDiscount",
    editClassPersonDiscount: "/api/DiscountGroup/EditClassPersonDiscount",
    list: "/api/DiscountGroup/List",
    delete: "/api/DiscountGroup/Delete",
    getById: "/api/DiscountGroup/GetById?Id=",
    activeDeactive: "/api/DiscountGroup/ActiveDeactive",
    ListByLevelInfoAndCoursePattern: "/api/DiscountGroup/ListByLevelInfoAndCoursePattern",
    discountPersonList: "/api/DiscountGroup/DiscountPersonList",
    discountPersonByNationalCode: "/api/DiscountGroup/DiscountPersonByNationalCode",
    listPersonDocument: "/api/DiscountGroup/ListPersonDocument",
    documentAdd: "/api/DiscountGroup/DocumentAdd",
    documentChangeDiscountGroup: "/api/DiscountGroup/DocumentChangeDiscountGroup",
    documentConfirmedReject: "/api/DiscountGroup/DocumentConfirmedReject",
    documentDelete: "/api/DiscountGroup/DocumentDelete",
    discountByTypeList: "/api/DiscountGroup/DiscountByTypeList?xIsClass=",
    getUnderstandingDiscountCombo: "/api/CustomerContractUN/GetUnderstandingDiscountCombo"

  };

  static packagePublic = {
    add: "/api/PackagePublic/Add",
    edit: "/api/PackagePublic/Edit",
    list: "/api/PackagePublic/List",
    getById: "/api/PackagePublic/ById"
  };

  static placementType = {
    add: "/api/PlacementType/Add",
    delete: "/api/PlacementType/Delete",
    activeDeactive: "/api/PlacementType/ActiveDeactive",
    list: "/api/PlacementType/List?PackageId=",
    listAll: "/api/PlacementType/ListAll?PackageId=",
    listCompany: "/api/PlacementType/ListCompany?xCompanyEncryptId="
  };

  static placementTimeSheet = {
    //add: "/api/PlacementTimeSheet/Add",
    add: "/api/PlacementTimeSheet/AddInBetweenDate",
    list: "/api/PlacementTimeSheet/List",
    edit: "/api/PlacementTimeSheet/Edit",
    delete: "/api/PlacementTimeSheet/Delete",
    getById: "/api/PlacementTimeSheet/GetById?xId=",
    getDateList: "/api/PlacementTimeSheet/GetDateList"
  };

  static placementReservation = {
    reservationAdd: "/api/PlacementReservation/ReservationAdd",
    placementReservationTime:
      "/api/PlacementReservation/PlacementReservationTime"
  };

  static placement = {
    getById: "/api/Placement/GetById?xId=",
    setPlacement: "/api/Placement/SetPlacement",
    list: "/api/Placement/List?BranchEncryptId=",
    getPlacementPersonList: "/api/Placement/GetPlacementPersonList?xDateEnd="
  };

  static registration = {
    add: "/api/Registration/Add",
    listCourseForRegister: "/api/Registration/ListCourseForRegister",
    getListLevelFromNationalCode:
      "/api/Registration/GetListLevelFromNationalCode?xNationalCode=",
    registerStudentList: "/api/Registration/RegisterStudentList",
    registerJustStudentList: "/api/Registration/RegisterStudentList",
    addPrivateClassRegistrationInvoice: "/api/Registration/AddPrivateClassRegistrationInvoice",
    cancelRegistration: "/api/Registration/CancelRegistration",
    addWithOutPlacement: "/api/Registration/AddWithOutPlacement",
    addAgh: "/api/Registration/AddAgh",
    removeAghRegistration: "/api/Registration/RemoveAghRegistration",
    removePrivateRegistration: "/api/Registration/RemovePrivateRegistration",
    registerFullList: "/api/Registration/RegisterFullList",
    setEduOrg: "/api/Registration/SetEduOrg",
    moveStudentToOtherClass: "/api/Registration/MoveStudentToOtherClass"
  };

  static parrentTerm = {
    list: "/api/ParentTerm/List",
    listComboByYear: "/api/ParentTerm/ListComboByYear?xYear=",
    getById: "/api/ParentTerm/GetById",
    add: "/api/ParentTerm/Add",
    edit: "/api/ParentTerm/Edit",
    ActiveDeActive: "/api/ParentTerm/ActiveDeActive"
  };

  static timesheet = {
    getTimeSheet: "/api/TimeSheet/GetTimeSheet",
    save: "/api/TimeSheet/Save"
  };

  static route = {
    ListForManager: "/api/Route/ListForManager",
    ListMenuForManagerUserAccess: "/api/Route/ListMenuForManagerUserAccess"
  };

  static wallet = {
    AddWalletCredit: "/api/Wallet/AddWalletCredit",
    CreateGonbadWalletInvoicePayment: "/api/Wallet/CreateGonbadWalletInvoicePayment",
    GetWallet: "/api/Waellt/GetWallet"
  };

  static invoce = {
    invoceWallet: "/api/Invoice/InvoceWallet",
    InvoiceComon: "/api/Invoice/InvoiceComon",
    invoceCommonGetById: "/api/Invoice/InvoiceComon?Id=",
    //invoiceCompany: "/api/Invoice/InvoiceCompanyForCurrentUser",
    invoiceCompany: "/api/Invoice/InvoiceCompanyAll",
    CancelInvoce: "/api/Invoice/CancelInvoce",
    getInvoiceVoucherRowForStudent: "/api/Invoice/GetInvoiceVoucherRowForStudent?xInvoiceId=",
    invoiceCompanyGetById: "/api/Invoice/InvoiceCompany?Id=",
    invoiceCompanyAll: "/api/Invoice/InvoiceCompanyAll",
    getInvoiceAllById: "/api/Invoice/InvoiceCompanyAll?Id=",
    getInvoiceInfoById: "/api/Invoice/GetInvoiceInfoById?xId=",
    paymnetConfirmation: "/api/Invoice/GetInvoiceOnlinePayment?xInvoiceOnlinePaymenId=",
    addAghInvoice: "/api/Invoice/AddAghInvoce",
    calcAghPlacementInvoice: "/api/Invoice/CalcAghPlacementInvoice?xContractId=",
    calcAghRegistrationInvoice: "/api/Invoice/CalcAghRegistrationInvoice?xContractId="
  };

  static invoceReject = {
    returnInvoice: "/api/InvoiceReject/ReturnInvoice",
    returnCalculation: "/api/InvoiceReject/ReturnCalculation",
    invoiceRejectCauseCombo: "/api/InvoiceReject/InvoiceRejectCauseCombo",
    payPayingPerson: "/api/InvoiceReject/PayPayingPerson",
    payToWalletPerson: "/api/InvoiceReject/PayToWalletPerson"
  };

  static pay = {
    getTocken: "/api/BankMelli/GetTocken",
    getSamanTocken: "/api/Bank/GetSamanTocken",
    //paymentCash: "/api/Payments/PaymentCash",
    GetWallet: "/api/Payments/GetWallet?xNationalCode=",
    GetActiveBank: "/api/Bank/GetActiveBank?xInvoiceId=",
    paymentCashemaining: "/api/Payments/PaymentCashemaining",
    paymentation: "/api/Payments/Paymentation",
    //Student
    GetWalletSTU: "/api/Payments/GetWalletSTU?xCompanyEncryptId=",
    paymentCashemainingSTU: "/api/Payments/PaymentCashemainingSTU"

  };

  static cash = {
    list: "/api/Cash/List?xBranchEncryptId=",
    add: "/api/Cash/Add",
    edit: "/api/Cash/Edit",
    activeDeactive: "/api/Cash/ActiveDeactive",
    personAdd: "/api/Cash/PersonAdd",
    personDelete: "/api/Cash/PersonDelete",
    getUserLoginCash: "/api/Cash/GetUserLoginCash"
  };

  static MarkType = {
    catList: "/api/MarkType/CatList",
    catAdd: "/api/MarkType/CatAdd",
    catEdit: "/api/MarkType/CatEdit",
    catGetById: "api/MarkType/CatGetById?=",
    catDelete: "api/MarkType/CatDelete?xId=",
    // number is mark-type1
    list: "/api/MarkType/List",
    add: "/api/MarkType/Add",
    edit: "/api/MarkType/Edit",
  };

  static MarkClassification = {
    list: "/api/MarkClassification/List",
    typeComboList: "/api/MarkClassification/TypeComboList",
    add: "/api/MarkClassification/Add",
    edit: "/api/MarkClassification/Edit",
  };

  static packageEducationBranch = {
    list: "/api/PackageEducationBranch/List",
    getById: "/api/PackageEducationBranch/PackageBranchGetById?xEducationPackageId=",
    add: "/api/PackageEducationBranch/Add",
    edit: "/api/PackageEducationBranch/Active",
    getBranches: "/api/PackageEducationBranch/GetBranchListByPackageId?xEducationPackageId=",
    activeDeactiveEducationPackageinBranch: "/api/PackageEducationBranch/Active"
  };

  static coupon = {
    listOwner: "/api/Coupon/ListOwner",
    addCoupon: "/api/Coupon/AddCoupon",
    activeDeactiveCouponAdmin: "/api/Coupon/ActiveDeactiveCouponAdmin",
    listUser: "/api/Coupon/ListUser?NationalCode=",
    listAllUser: "/api/Coupon/ListAllUser?NationalCode=",
    addCouponToMyself: "/api/Coupon/AddCouponToMyself",
    assignCouponToStudent: "/api/Coupon/AssignCouponToStudent",
    deleteCouponToMyself: "/api/Coupon/DeleteCouponToMyself",
    couponCategory: "/api/CouponCategory/ListCombobox",
    //Student
    listUserSTU: "/api/Coupon/ListUserSTU",
  };

  static marketer = {
    save: "/api/Marketer/Save",
    delete: "/api/Marketer/DeleteMarketer",
    list: "/api/Marketer/List?CompanyEncryptId="
  }

  static report = {
    placement: {
      tokenPlacementReceipt: "/api/Placement/TokenPlacementReceipt",
      tokenPlacementList: "/api/Placement/TokenPlacementList"
    },
    register: {
      tokenRegisterList: "/api/Registration/TokenRegisterList"
    },
    financial: {
      GetPlacmectPaymentShow: "Financial/GetPlacmectPaymentShow",
      GetRegistrationPaymentShow: "Financial/GetRegistrationPaymentShow",
      GetRejectShow: "Financial/GetRejectShow",
      GetPlacementRejectShow: "Financial/GetPlacementRejectShow",
      GetUsedCouponsShow: "Financial/GetUsedCouponsShow",
      GetRegistrationPaymentIgnoreDateShow: "Financial/GetRegistrationPaymentIgnoreDateShow"
    },
    education: {
      GetPlacmectRegistredShow: "Education/GetPlacmectRegistredShow",
      GetPlacmectNotRegistredShow: "Education/GetPlacmectNotRegistredShow",
      GetStudentsShow: "Education/GetStudentsShow",
      GetNewStudentRegistrationShow: "Education/GetNewStudentRegistrationShow",
      CountRegisterationShow: "Education/CountRegisterationShow",
      ThursdayOnedayAWeekCorseShow: "Education/ThursdayOnedayAWeekCorseShow",
      GetCorseByPatternShow: "Education/GetCorseByPatternShow",
      GetCorseByPatternWithoutTimeShow: "Education/GetCorseByPatternWithoutTimeShow",
      FridayOnedayAWeekCorseList: "Education/FridayOnedayAWeekCorseShow",
      TeacherCourseShow: "Education/TeacherCourseShow",
      GetCorseByEmptyShow: "Education/GetCorseByEmptyShow",
      GetSuspendedStudentShow: "Education/GetSuspendedStudentShow",
      GetStudentFallShow: "Education/GetStudentFallShow",
      RegistrationBranchShow: "Education/RegistrationBranchShow",
      CourseBranchShow: "Education/CourseBranchShow",
      GetMarkStsShow: "Education/GetMarkStsShow",
      GetEduCountLevelStsShow: "Education/GetEduCountLevelStsShow",
      GetCourseCancelShow: "Education/GetCourseCancelShow",
      GetContractBranchPackegeShow: "Education/GetContractBranchPackegeShow",
      GetTeachersPlacmentShow: "Education/GetTeachersPlacmentShow",
      GetEduCountPatternStsShow: "Education/GetEduCountPatternStsShow",
      GetEduSessionNotCheckoutShow: "Education/GetEduSessionNotCheckoutShow",
      GetEduTeachereSessionSubShow: "Education/GetEduTeachereSessionSubShow",
      GetEduTeachereMackupSessionShow: "Education/GetEduTeachereMackupSessionShow",
      GetEmployeeAcademicAchievementShow: "Education/GetEmployeeAcademicAchievementShow",
      GetTeacherLevelShow: "Education/GetTeacherLevelShow",
      GetDiscountRegistrationShow: "Education/GetDiscountRegistrationShow",
      GetTeacherTimeSheetShow: "Education/GetTeacherTimeSheetShow",
      GetGraduatedStudentShow: "Education/GetGraduatedStudentShow",
      GetSessionShow: "Education/GetSessionShow",
      GetAllTeacherObservationShow: "Education/GetAllTeacherObservationShow",
      GetDetailTeacherObservationShow: "Education/GetDetailTeacherObservationShow",
      GetTPATeacherCountShow: "Education/GetTPATeacherCountShow"
    },
    salary: {
      GetTeacherFunctionShow: "Salary/GetTeacherFunctionShow",
      GetTeacherWorkingShow: "Salary/GetTeacherWorkingShow",
    },
    management: {
      GetCourseIncomeShow: "Management/GetCourseIncomeShow",
      GetCourseIncomeByPatternShow: "Management/GetCourseIncomeByPatternShow",
      GetContractShow: "Management/GetContractShow",
      GetTeacherSurveyShow: "Management/GetTeacherSurveyShow",
      GetLoyaltyStudentShow: "Management/GetLoyaltyStudentShow",
      GetPlacmentPerformedInBranchShow: "Management/GetPlacmentPerformedInBranchShow",
      GetStudentFallCompanyShow: "Management/GetStudentFallCompanyShow"
    },
    eduOrg: {
      GetCorseByPatternShow: "EduOrg/GetCorseByPatternShow",
      GetEduOrgStudentShow: "EduOrg/GetEduOrgStudentShow"
    }
  }

  static studentSessionsCheckout = {
    cource: {

      getCoursePackageId: "/api/Course/GetCoursePackageId?xCourseId=",
      getStudentAttendance: "/api/Course/GetStudentAttendance",
      saveStudentAttendance: "/api/Course/SaveStudentAttendance"
    },
    markStudent: {
      getMarkStudentList: "/api/MarkStudent/List",
      setToFinal: "/api/MarkStudent/SetToFinal",
      save: "/api/MarkStudent/Save"

    },
    markClassification: {
      listCombo: "/api/MarkClassification/ListCombo",
    },
    markType: {
      listCombo: "/api/MarkType/ListCombo",
    },

  }
  static student = {
    getTest: "/api/test/test",
    registration : {
      getLatestRegistrationArea: "/api/Registration/GetLatestRegistrationArea?xNationalCode=",
      getNextLevelForQuickRegister: "/api/Registration/GetNextLevelForQuickRegister?xHoldingEncryptId="
    },
    course: {
      getRegistrationCourses: "/api/Registration/GetRegistrationStudentStatusSTU",
      markStudentSTU: "/api/MarkStudent/MarkStudentSTU?xRegistrationId=",
      questionListStudentNotAnswerSTU: "/api/SurSurvey/QuestionListStudentNotAnswerSTU?xRegisterId=",
      getListLevelFromNationalCodeSTU: "/api/Registration/GetListLevelFromNationalCodeSTU?xHoldingEncryptId=",
      getCourseInfoById: "/api/Course/GetCourseInfoById?xid=",
      getBranchListByNationalCodeAndPackageSTU: "/api/PackageEducation/GetBranchListByNationalCodeAndPackageSTU",
      courseTypeListByCurentBranchSTU: "/api/CourseType/CourseTypeListByCurentBranchSTU?xBranchEncryptId=",
      courseTypeListByCurentBranchAndLevelSTU: "/api/CourseType/CourseTypeListByCurentBranchAndLevelSTU?xBranchEncryptId=",
      listByJustCourseTypeIdSTU: "/api/TermInfo/ListByJustCourseTypeIdSTU",
      surveyListAdd: "/api/SurSurvey/SurveyListAdd",
      listCourseForRegister: "/api/Registration/ListCourseForRegister",
      listCourseForRegisterSTU: "/api/Registration/ListCourseForRegisterSTU",
      discountPersonListSTU: "/api/DiscountGroup/DiscountPersonByNationalCodeSTU?CourseId=",
      getUnderstandingDiscountCombo: "/api/CustomerContractUN/GetUnderstandingDiscountCombo?CourseId=",
      addSTU: "/api/Registration/AddSTU",
    },
    placement: {
      getListSTU: "/api/Placement/ListSTU",
      getPlacementReservations: "/api/Placement/TokenPlacementReceipt",
      reservationAdd: "/api/PlacementReservation/ReservationAddSTU",
      placementTypeListSTU: "/api/PlacementType/ListSTU",
      getDateList: "/api/PlacementTimeSheet/GetDateList",
      placementReservationTimeSTU: "/api/PlacementReservation/PlacementReservationTimeSTU"

    },
    discount: {
      getPersonDocuments: "/api/DiscountGroup/ListPersonDocumentSTU",
      sendDocument: "/api/DiscountGroup/DocumentAddSTU",
      editDocument: "/api/DiscountGroup/DocumentChangeDiscountGroupSTU",
      documentDeleteSTU: "/api/DiscountGroup/DocumentDeleteSTU",
      discountGroupPersonList: "/api/DiscountGroup/ListDiscountGroupPersonSTU"
    },
    invoce: {
      invoiceComonSTU: "/api/Invoice/InvoiceComonSTU",
      GetInvoiceVoucherRowForStudent: "/api/Invoice/GetInvoiceVoucherRowForStudent?InvoiceId="
      // editDocument:"/api/DiscountGroup/DocumentChangeDiscountGroup"

    },
  }
// ادرس سرویس های مربوط به قسمت راهنمایی
  static guidance = {
    getParents: "/api/GuideRoute/GetAllParentGuide",
    getAllChildByParentId: "/api/GuideRoute/GetAllChildGuideByParentId",
    getParentGuidByRoute: "/api/GuideRoute/GetParentGuideByRoute",
    getGuidByComponent: "/api/GuideRoute/GetGuideByComponent",
    getAllGuideBySearch: "/api/GuideRoute/GetAllGuideBySearch",
    getRoot: "/api/GuideRoute/GetAllParentsIdList"
  }
  // subsidiary ادرس تمامی سرویس های مربوط به اقماری
  static subsidiary = {
    //(customer) ادرس تمامی سرویس های مربوط به شرکت های اقماری
    company: {
      getCustomerListCombo: "/api/Customer/ListCombo",
      getCustomerList: "/api/Customer/List",
      customerAdd: "/api/Customer/Add",//ثبت مشتری C
      customerEdit: "/api/Customer/Edit", //  ویرایش مشتری C
      customerActiveDeactive: "/api/Customer/ActiveDeactive", // فعال و غیر فعال کردن C
    },
    //(customer) ادرس تمامی سرویس های مربوط به نمایندگان در شرکت های اقماری
    agent: {
      getCustomerAgentListCombo: "/api/Customer/ListCombo",
      getCustomerAgentList: "/api/Customer/ListAgent", // لیست نماینده ها C
      customerAgentAdd: "/api/Customer/AddAgent", // ثبت نماینده C
      customerAgentEdit: "/api/Customer/EditAgent", // ویرایش نماینده C
    },
    // ادرس تمامی سرویس های مربوط به تعیین عضویت در شرکت های اقماری
    placement: {
      aghPlacementAdd: "/api/PlacementReservation/AghPlacementAdd", //ثبت تعیین سطح های رزرو شده برای اقماری C
      aghPlacementCheck: "/api/PlacementReservation/AghPlacementCheck", //بررسی تعیین سطح برای اقماری C
    },
    // ادرس تمامی سرویس های مربوط به تفاهم نامه های اقماری
    memorandum: {
      getUnderstandingList: "/api/CustomerContractUN/UnderstandingList", //لیست تفاهم نامه ها C
      understandingAdd: "/api/CustomerContractUN/UnderstandingAdd",//ثبت تفاهم نامه C
      understandingEdit: "/api/CustomerContractUN/UnderstandingEdit", //  ویرایش تفاهم نامه C
      understandingDelete: "/api/CustomerContractUN/UnderstandingDelete", //  حذف تفاهم نامه C
      getUnderstandingNationalList: "/api/CustomerContractUN/UnderstandingNationalList", // لیست کد ملی های ارسال شده برای تفاهم نامه C
      understandingNationalAdd: "/api/CustomerContractUN/UnderstandingNationalAdd", // ثبت کد ملی برای تفاهم نامه بصورت مستقیم C
      understandingNationalAddWithFile: "/api/CustomerContractUN/UnderstandingNationalAddWithFile", // ثبت کد ملی برای تفاهم نامه با فایل C
      understandingNationalDelete: "/api/CustomerContractUN/UnderstandingNationalDelete", // حذف کد ملی از لیست کد ملی های تفاهم نامه C
      getUnderstandingDiscountCombo: "/api/CustomerContractUN/GetUnderstandingDiscountCombo", // لیست تخفیف برای شخص جهت ثبت نام

    },
    // ادرس تمامی سرویس های مربوط به قرارداد های اقماری
    contract: {
      getCustomerContractList: "/api/CustomerContractCO/CustomerContracList", //لیست قرارداد ها C
      customerContractAdd: "/api/CustomerContractCO/CustomerContracAdd", //ثبت قرارداد مشتری : قراردادی که محل تشکل آن کلاس ها در شعبه نمی باشد و محل برگزاری به عهده مشتری است  C
      customerContractEdit: "/api/CustomerContractCO/CustomerContracEdit", //ویرایش قراردادهایی که هیچ دوره ای برای آن تعریف نشده باشد C
      customerContractDelete: "/api/CustomerContractCO/CustomerContracDelete", //حذف قراردادهایی که هیچ دوره ای برای آن تعریف نشده باشد C
      customerContractAddRoom: "/api/CustomerContractCO/CustomerContractAddRoom",
      customerContractTermInfoList: "/api/CustomerContractCO/CustomerContractTermInfoList?xCustomerContractId=", //لیست ترم هایی که برای این قرارداد قابل دسترسی است C
      customerContractTermInfoCurrentList: "/api/CustomerContractCO/CustomerContractTermInfoCurrentList", //لیست ترم هایی که که برای این قرارداد ثبت شده است C
      customerContractTermInfoAdd: "/api/CustomerContractCO/CustomerContractTermInfoAdd", // ثبت توضیحات ترم به قرارداد  C
      customerContractTermInfoDelete: "/api/CustomerContractCO/CustomerContractTermInfoDelete", // حذف ترم برای قرارداد C
      ChangeCustomerContractPersonAddState: "/api/CustomerContract/ChangeCustomerContractPersonAddState",
      GetCustomerContractPersonAddState: "/api/CustomerContract/GetCustomerContractPersonAddState?xCustomerContracId="
    },
    // ادرس تمامی سرویس های مربوط به پنل اقماری
    dashboard: {
      // ادرس تمامی سرویس های مربوط به قرارداد های پنل اقماری
      contract: {
        getUserAgentList: "/api/Customer/GetUserAgentList" //لیست قرارداد هایی که کاربر در آن به عنوان نماینده می باشد
      },
      // ادرس تمامی سرویس های مربوط به دانشجویان در پنل اقماری
      student: {
        getStudentsInContract: "/api/CustomerContractCO/CustomerContractNationalCodeList", //لیست کد ملی های ارسال شده برای قرارداد C,
        ContractFileXLS: "/api/CustomerContractCO/CustomerContractPersonNationalCodeAddWithFile", //لیست کد ملی های ارسال شده برای قرارداد C,
        contractPersonDirectAdd: "/api/CustomerContractCO/CustomerContractPersonNationalCodeDirectAdd" //لیست کد ملی های ارسال شده برای قرارداد C
      },

    }





  }


}
